import { render, staticRenderFns } from "./addCurrencies.vue?vue&type=template&id=b4cf95b2&scoped=true"
import script from "./addCurrencies.vue?vue&type=script&lang=js"
export * from "./addCurrencies.vue?vue&type=script&lang=js"
import style0 from "./addCurrencies.vue?vue&type=style&index=0&id=b4cf95b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf95b2",
  null
  
)

export default component.exports